import jsPsychAudioButtonResponse from '@jspsych/plugin-audio-button-response';
import store from 'store2';
import { mediaAssets, updateProgressBar } from '../helperFunctions';
import '../../styles/custom.scss';

// post block page
const post_block_page_1 = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['07Mid1T'];
    }
    return mediaAssets.audio.break1Ns;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      return `
      <img class="scene" src="${mediaAssets.images.backgroundMachine}" />
      <img class = 'mid-break-alien-1' src="${mediaAssets.images.alienPinkWaving}"/>
      <div class = "instructionText">
      <h1>Thanks for helping out!</h1>
      <p class="center">You've reached a Zaga Outpost on your journey. 
      <br>
      <br> 
      You meet a new Zorp who shows you a cool new machine they've invented! Wow!</p>
      </div>`;
    }
    return `
    <img class="instructionCanvas" src="${mediaAssets.images.backgroundStarsky}"</img>
    <h4> Great job! You're 1/3rd of the way through. </h4>
    <p class="center"> Feel free to take a short break and continue whenever you are ready. </p>
    `;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
};

const post_block_page_2 = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['08Mid2T'];
    }
    return mediaAssets.audio.break2Ns;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      return `
      <img class="scene" src="${mediaAssets.images.backgroundLake}" />
      <img class = 'mid-break-alien-1' src="${mediaAssets.images.alienPurpleWalking}" >
      <div class = "instructionText">
      <h1>Wonderful!</h1>
      <p class="center">After a few days of exploring the planet with your new friends, you come across a lake.
      <br>
      <br> 
      There, you meet another friendly Zorp, Zelek, who studies the animals who live near the water. </p> </div>
      `;
    }
    return `
    <img class="instructionCanvas" src="${mediaAssets.images.backgroundStarsky}"</img>
    <h4> Great job! You're 2/3rd of the way through.</h4>
    <p class="center"> Feel free to take a short break and continue whenever you are ready. </p>
    `;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
};

const final_page = {
  type: jsPsychAudioButtonResponse,
  on_start: () => {
    updateProgressBar(true);
  },
  on_load: () => {
    clearTimeout(store.session.get('maxTimerId'));
  },
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['09FinalT'];
    }
    return mediaAssets.audio.endNs;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      return `
      <img class="scene" src="${mediaAssets.images.backgroundSpaceship}" />
      <div>
      <h1>We’ve all learned so much! </h1>
      <div>
      <p class="center">Thanks for helping! </p>
      <p class="center"> You’ve made it to the space station where you can get on a spaceship to go back to Earth. </p> 
      <p>Let’s come back again soon! </p>
      </div>
      <img class = 'goodbye_aliens' src="${mediaAssets.images.alienPinkJumping}" >
      <img class = 'goodbye_aliens' src="${mediaAssets.images.alienYellowWaving}" >
      <img class = 'goodbye_aliens' src="${mediaAssets.images.alienBlueJumping}" >
      <img class = 'goodbye_aliens' src="${mediaAssets.images.alienGreenWaving}" >
      <img class ='goodbye_aliens' src="${mediaAssets.images.alienPurpleWalking}">
      </div>`;
    }
    return `
    <img class="instructionCanvas" src="${mediaAssets.images.backgroundStarsky}"</img>
    <h4> Thank you for completing the Vocabulary activity. </h4>
    <p class="center"> Click the button to save your data. </p>
    `;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
  // trial_ends_after_audio: true,
};

const post_block_page_list = [post_block_page_1, post_block_page_2];

export { post_block_page_list, final_page };
